import { create } from 'zustand';

import { MyProfile } from '@/types/my-profile.type';

interface MyProfileState {
  myProfile: MyProfile | undefined;
  setMyProfile: (myProfile: MyProfile) => void;
}

const useMyProfileStore = create<MyProfileState>((set) => ({
  myProfile: undefined,
  setMyProfile: (myProfile: MyProfile) => set(() => ({ myProfile })),
}));

export default useMyProfileStore;
